import { ReactiveMutableSet2bktc9g3zyrtk as ReactiveMutableSet } from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveMutableSet.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { shownWhen3t7othivfr11 as shownWhen } from '../direct/modifiers.commonHtml.mjs';
import {
  SubtextSemantic_getInstance1duu1ll1kgx8d as SubtextSemantic_getInstance,
  ErrorSemantic_getInstance1asme2of31cag as ErrorSemantic_getInstance,
} from '../../models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../themeDerivations.mjs';
import {
  TextViewe6rp77b08kos as TextView,
  TextView$_get_content_$ref_4pzcwl16uunx6j4t5r9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb3nnz1ag2pn6vb as TextView$_set_content_$ref_pketfb,
} from '../direct/TextView.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../NativeElement.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ExceptionHandler3ohep65iljyrj as ExceptionHandler } from '../../exceptions/handling.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { exceptionMessage1cx0ho62128p8 as exceptionMessage } from '../ElementContext.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { LiveRegionMode_Assertive_getInstanceh7tqh38ym97g as LiveRegionMode_Assertive_getInstance } from '../../models/LiveRegionMode.mjs';
import { generateSequence118suk3hffuuw as generateSequence } from '../../../../../../kotlin-kotlin-stdlib/kotlin/sequences/Sequences.mjs';
import { findFirstInteractiveDescendant11suf5uyp4f72 as findFirstInteractiveDescendant } from './labels.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function errorText(_this__u8e3s4) {
  var errors = ReactiveMutableSet().new_com_lightningkite_reactive_core_ReactiveMutableSet_72mh0y_k$();
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_0 = themed(themed(shownWhen(_this__u8e3s4, VOID, VOID, ($this$shownWhen) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$shownWhen.invoke_r7m7el_k$(errors).isEmpty_y1axqb_k$();
  }), SubtextSemantic_getInstance()), ErrorSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (TextView())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  var $this$text = element;
  var tmp = _this__u8e3s4.get_context_h02k06_k$().exceptionHandlers_1;
  tmp.plusAssign_4ugdj3_k$(ExceptionHandler(1.0, ($this$ExceptionHandler, it) => {
    errors.add_wl2rvy_k$(it);
    return () => {
      errors.remove_an8aut_k$(it);
      return Unit_instance;
    };
  }));
  var tmp_0 = KMutableProperty0();
  var tmp_1 = TextView$_get_content_$ref_4pzcwl($this$text);
  var tmp_2 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb($this$text));
  $this$text.invoke_bnq13k_k$(tmp_2, ($this$invoke) => {
    var tmp = $this$invoke.invoke_r7m7el_k$(errors);
    return joinToString(tmp, '\n', VOID, VOID, VOID, VOID, (it) => {
      var tmp0_safe_receiver = exceptionMessage($this$text.get_context_h02k06_k$(), it);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.body_1;
      var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? it.message : tmp1_elvis_lhs;
      return tmp2_elvis_lhs == null ? it.toString() : tmp2_elvis_lhs;
    });
  });
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
  var errorView = element;
  errorView.set_accessibleLiveRegion_kq920e_k$(LiveRegionMode_Assertive_getInstance());
  var tmp_3 = errorView.get_parent_hy4reb_k$();
  var tmp0 = generateSequence(tmp_3, errorText$lambda);
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlin.sequences.firstNotNullOfOrNull' call
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element_0 = _iterator__ex2g4s.next_20eer_k$();
      var result = findFirstInteractiveDescendant(element_0);
      if (!(result == null)) {
        tmp$ret$4 = result;
        break $l$block;
      }
    }
    tmp$ret$4 = null;
  }
  var tmp0_safe_receiver = tmp$ret$4;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    tmp0_safe_receiver.set_describedBy_4bf3cf_k$(errorView);
  }
}
function errorText$lambda(it) {
  return it.get_parent_hy4reb_k$();
}
//region block: exports
export {
  errorText as errorText83fzxqvlxz6i,
};
//endregion

//# sourceMappingURL=shortstuff.mjs.map
